module.exports = __webpack_public_path__ + "img/verified-blue.cc79486b.svg";